/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface ResponseBase
 */
export interface ResponseBase {
    /**
     * @type {string}
     * @memberof ResponseBase
     */
    message?: string;
    /**
     * @type {string}
     * @memberof ResponseBase
     */
    reason: ResponseBaseReasonEnum;
    /**
     * @type {number}
     * @memberof ResponseBase
     */
    total?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum ResponseBaseReasonEnum {
    Ok = 'ok',
    Created = 'created',
    InvalidField = 'invalid_field',
    NoData = 'no_data',
    NotFound = 'not_found',
    NotImplemented = 'not_implemented',
    Restricted = 'restricted',
    ServerError = 'server_error'
}

